
import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  TextField,
  Button,
  TableHead,
  FormControl,
  TableBody,
  TableCell,
  TableContainer,
  Table,
  TableRow,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Paper,
  Box,
  IconButton,
    Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

const NewbornForm = () => {
  // Initial form state
  const [formData, setFormData] = useState({
    // Demographics
    dateOfBirth: '',
    testDate: '',
    ipOpInternal: '',
    name: '',
    address: '',
    telephone: '',
    region: '',
    age: '',
    ageindays: '',
    gender: '',

    // Family Background
    selectedFamilyBackground: '',
    familyBackgroundItems: [],
    othersFamily: '',

    // Prenatal History
    diabetes: '',
    specifyDiabetes: '',
    bp: '',
    specifyBp: '',
    vomiting: '',
    specifyVomiting: '',
    elderlyPregnancy: '',
    abortion: '',
    specifyAbortion: '',
    ototoxicMedication: '',
    radiationExposure: '',
    rhIncompatibility: 'Negative',
    infections: '',
    specifyInfections: '',
    habits: {
      alcohol: '',
      smoking: ''
    },
    complications: '',
    specifyComplications: '',

    // Perinatal History
    fullTerm: '',
    premature: '',
    jaundice: '',
    jaundiceTiming: '',
    treatment: '',
    deliveryType: 'Normal',
    prolongedLabour: '',
    birthCry: 'Immediate',
    delayedCryDuration: '',
    nicu: '',
    nicuDays: '',
    apgarImmediate: '',
    apgar5min: '',
    hypoxia: '',
    headTrauma: '',
    neonatalJaundice: '',
    fetalDistress: '',
    birthAsphyxia: '',
    amnioticAspiration: '',
    vegetativeSkills: 'Good',
    postnatalInfections: '',
    specifyPostnatalInfections: '',
    otherFindings: '',

    // Post Natal History & Reflexes
    reflexes: {
      moro: '',
      rooting: '',
      sucking: '',
      tonic: '',
      babinski: '',
      palmar: '',
      plantar: ''
    },

    // Tests
    oae: {
      type: '',
      trial: '',
      rightResult: '',
      leftResult: ''
    },
    boa: {
      trial: '',
      // Initial state for formData.boa.responses:
      responses: {
        "500 Hz": { intensity: "", response: "" },
        "1k Hz": { intensity: "", response: "" },
        "2k Hz": { intensity: "", response: "" },
        "4k Hz": { intensity: "", response: "" },
        "Speech": { intensity: "", response: "" },
        "Noise": { intensity: "", response: "" }
      },
      results: ''
    },
    aabr: {
      trial: '',
      responses: {
        '30': { right: '', left: '' },
        '35': { right: '', left: '' },
        '40': { right: '', left: '' }
      },
      results: ''
    },

    // Diagnosis & Recommendation
    diagnosis: '',
    recommendation: {
      pediatrician: false,
      psychologist: false,
      ot: false,
      pt: false,
      ent: false,
      hat: false,
      earmold: false,
      speechTherapy: false,
      speechEvaluation: false,
      audiologicalEvaluation: false
    }
  });
   const [loading, setLoading] = useState(false);
      const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
      const [openPasswordModal, setOpenPasswordModal] = useState(false);
      const [password, setPassword] = useState('');
      const [downloadFormat, setDownloadFormat] = useState('excel');
  useEffect(() => {
    if (formData.dateOfBirth && formData.testDate) {
      const birthDate = new Date(formData.dateOfBirth);
      const testDate = new Date(formData.testDate);

      // Only calculate if both dates are valid
      if (!isNaN(birthDate.getTime()) && !isNaN(testDate.getTime())) {
        const diffTime = testDate - birthDate;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        setFormData(prev => ({ ...prev, ageindays: diffDays.toString() }));
      }
    }
  }, [formData.dateOfBirth, formData.testDate]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };


  const handleAabrResponseChange = (intensity, ear, value) => {
    setFormData(prev => {
      const responses = { ...prev.aabr.responses };
      responses[intensity] = { ...responses[intensity], [ear]: value };
      return {
        ...prev,
        aabr: {
          ...prev.aabr,
          responses
        }
      };
    });
  };
  const handleNestedChange = (parent, field, value) => {
    setFormData(prev => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [field]: value
      }
    }));
  };

  const handleAddFamilyBackground = () => {
    if (formData.selectedFamilyBackground &&
      !formData.familyBackgroundItems.includes(formData.selectedFamilyBackground)) {
      setFormData(prev => ({
        ...prev,
        familyBackgroundItems: [...prev.familyBackgroundItems, prev.selectedFamilyBackground],
        selectedFamilyBackground: ''
      }));
    }
  };

  const handleRemoveFamilyBackground = (item) => {
    setFormData(prev => ({
      ...prev,
      familyBackgroundItems: prev.familyBackgroundItems.filter(i => i !== item)
    }));
  };


  const handleBoaChange = (stimulus, field, value) => {
    setFormData(prev => ({
      ...prev,
      boa: {
        ...prev.boa,
        responses: {
          ...prev.boa.responses,
          [stimulus]: {
            ...prev.boa.responses[stimulus],
            [field]: value
          }
        }
      }
    }));
  };
  
const handleSubmit = async (e) => {
  e.preventDefault();
  
  try {
    const submitData = {
      formData
    };

    console.log('Submitting data:', submitData);

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/newborn`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(submitData),
    });

    if (response.ok) {
      const result = await response.json();
      alert('Newborn hearing screening data saved successfully!');
      
      // Reset form after successful submission
      setFormData({
        dateOfBirth: '',
        testDate: '',
        ipOpInternal: '',
        name: '',
        address: '',
        telephone: '',
        region: '',
        age: '',
        ageindays: '',
        gender: '',
        selectedFamilyBackground: '',
        familyBackgroundItems: [],
        othersFamily: '',
        diabetes: '',
        specifyDiabetes: '',
        bp: '',
        specifyBp: '',
        vomiting: '',
        specifyVomiting: '',
        elderlyPregnancy: '',
        abortion: '',
        specifyAbortion: '',
        ototoxicMedication: '',
        radiationExposure: '',
        rhIncompatibility: 'Negative',
        infections: '',
        specifyInfections: '',
        habits: { alcohol: '', smoking: '' },
        complications: '',
        specifyComplications: '',
        fullTerm: '',
        premature: '',
        jaundice: '',
        jaundiceTiming: '',
        treatment: '',
        deliveryType: 'Normal',
        prolongedLabour: '',
        birthCry: 'Immediate',
        delayedCryDuration: '',
        nicu: '',
        nicuDays: '',
        apgarImmediate: '',
        apgar5min: '',
        hypoxia: '',
        headTrauma: '',
        neonatalJaundice: '',
        fetalDistress: '',
        birthAsphyxia: '',
        amnioticAspiration: '',
        vegetativeSkills: 'Good',
        postnatalInfections: '',
        specifyPostnatalInfections: '',
        otherFindings: '',
        reflexes: {
          moro: '', rooting: '', sucking: '', tonic: '', 
          babinski: '', palmar: '', plantar: ''
        },
        oae: { type: '', trial: '', rightResult: '', leftResult: '' },
        boa: {
          trial: '',
          responses: {
            "500 Hz": { intensity: "", response: "" },
            "1k Hz": { intensity: "", response: "" },
            "2k Hz": { intensity: "", response: "" },
            "4k Hz": { intensity: "", response: "" },
            "Speech": { intensity: "", response: "" },
            "Noise": { intensity: "", response: "" }
          },
          results: ''
        },
        aabr: {
          trial: '',
          responses: {
            '30': { right: '', left: '' },
            '35': { right: '', left: '' },
            '40': { right: '', left: '' }
          },
          results: ''
        },
        recommendation: {
          pediatrician: false, psychologist: false, ot: false, pt: false,
          ent: false, hat: false, earmold: false, speechTherapy: false,
          speechEvaluation: false, audiologicalEvaluation: false
        }
      });
    } else {
      const errorData = await response.json();
      alert(`Failed to save: ${errorData.error}`);
    }
  } catch (error) {
    console.error('Error submitting form:', error);
    alert('Error submitting newborn hearing screening data');
  }
};

 const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

const handleDownloadConfirm = async () => {
  const correctKey = "Varun@6361";

  // Validate key entered in modal
  if (password !== correctKey) {
    alert("Incorrect key! Download canceled.");
    setPassword('');
    setOpenPasswordModal(false);
    return;
  }

  setOpenPasswordModal(false);
  setLoading(true);
  setSaveStatus({
    message: `Requesting Newborn Hearing Screening ${downloadFormat}...`,
    severity: "info",
  });

  try {
    const resp = await fetch(
      `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          table: "newborn_hearing_screening",
          formName: "Newborn_Hearing_Screening",
          format: downloadFormat,
          key: password   // 🔥 send KEY instead of password
        }),
      }
    );

    if (!resp.ok) {
      const body = await resp.json().catch(() => ({}));
      setSaveStatus({
        message: `Failed: ${body.message || resp.statusText}`,
        severity: "error",
      });
      return;
    }

    const blob = await resp.blob();
    const disposition = resp.headers.get("content-disposition") || "";

    let filename = `Newborn_Hearing_Screening_${Date.now()}.${
      downloadFormat === "excel" ? "xlsx" : "pdf"
    }`;

    const match = /filename="?([^"]+)"?/.exec(disposition);
    if (match && match[1]) filename = match[1];

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    setSaveStatus({
      message: `Download started: ${filename}`,
      severity: "success",
    });

  } catch (err) {
    console.error("Download error:", err);
    setSaveStatus({
      message: `Error downloading file: ${err.message}`,
      severity: "error",
    });
  } finally {
    setLoading(false);
    setPassword('');
  }
};


  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };
  // Map for demographic field labels
  const demographicFields = [
    { id: 'ipOpInternal', label: 'IP/OP/Internal' },
    { id: 'name', label: 'Name' },
    { id: 'address', label: 'Address' },
    { id: 'telephone', label: 'Telephone' },
    { id: 'region', label: 'Region' },
    { id: 'age', label: 'Age' },
    { id: 'ageindays', label: 'Age in Days', disabled: true },
  ];

  // Recommendation services
  const recommendationServices = [
    { label: "Pediatrician", field: "pediatrician" },
    { label: "Psychologist", field: "psychologist" },
    { label: "OT", field: "ot" },
    { label: "PT", field: "pt" },
    { label: "ENT", field: "ent" },
    { label: "HAT", field: "hat" },
    { label: "Earmold", field: "earmold" },
    { label: "Speech Therapy", field: "speechTherapy" },
    { label: "Speech Evaluation", field: "speechEvaluation" },
    { label: "Audiological Evaluation", field: "audiologicalEvaluation" },
     { label: "Follow Up", field: "followUp" },
  ];

  return (
    <Paper elevation={3} sx={{ p: 3, margin: '20px auto', maxWidth: '1200px' }}>
       <Box sx={{ position: 'absolute', top: 230, right: 250 }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadClick}
                disabled={loading}
                sx={{ 
                  borderRadius: 2,
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 4,
                    transform: 'translateY(-2px)',
                    transition: 'all 0.3s ease'
                  }
                }}
              >
                Download 
              </Button>
            </Box>
      <Typography variant="h4" gutterBottom fontWeight="bold" color="secondary" align="center">
        Newborn Hearing Screening
      </Typography>

      <form onSubmit={handleSubmit}>
        {/* Demographics Section */}
        <Typography variant="h5" gutterBottom sx={{ mt: 3, mb: 2, color: 'primary.main' }}>
          Demographics
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {/* Date of Birth */}
          <Grid item xs={12} sm={6} md={4}> 
            <TextField
              fullWidth
              label="Date of Birth"
              name="dateOfBirth"
              type="date"
              value={formData.dateOfBirth}
              onChange={handleChange}
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* Test Date */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Test Date"
              name="testDate"
              type="date"
              value={formData.testDate}
              onChange={handleChange}
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* Other demographic fields */}
          {demographicFields.map(({ id, label, disabled }) => (
            <Grid item xs={12} sm={6} md={4} key={id}>
              <TextField
                fullWidth
                label={label}
                name={id}
                value={formData[id]}
                onChange={handleChange}
                variant="outlined"
                size="small"
                disabled={disabled || false}
              />
            </Grid>
          ))}

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel shrink={true}>Gender</InputLabel>
              <Select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                label="Gender"
                displayEmpty
                renderValue={value => value || "Select Gender"}
              >
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Family Background Section */}
        <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
          Family Background
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel shrink={true}>Family History</InputLabel>
              <Select
                name="selectedFamilyHistory"
                value={formData.selectedFamilyBackground || ''}
                onChange={handleChange}
                label="Family History"
                displayEmpty
                renderValue={value => value || "Select Family History"}
              >
                <MenuItem value="">Select an option</MenuItem>
                <MenuItem value="Speech Problem">Speech Problem</MenuItem>
                <MenuItem value="Hearing Impairment">Hearing Impairment</MenuItem>
                <MenuItem value="Mental Retardation">Mental Retardation</MenuItem>
                <MenuItem value="Neurological Disorder">Neurological Disorder</MenuItem>
                <MenuItem value="Congenital Defects">Congenital Defects</MenuItem>
                <MenuItem value="Physical Defects">Physical Defects</MenuItem>
                <MenuItem value="Sibling History">Sibling History</MenuItem>
                <MenuItem value="None">None</MenuItem> 
                <MenuItem value="Others">Others</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {formData.familyBackgroundItems.length > 0 && (
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {formData.familyBackgroundItems.map((item, index) => (
              <Grid container item xs={12} key={index} spacing={2} alignItems="center">
                <Grid item xs={5}>
                  <Typography variant="body1">{item}</Typography>
                  {item === 'Others' && (
                    <TextField
                      fullWidth
                      label="Specify Others"
                      name="othersFamily"
                      value={formData.othersFamily}
                      onChange={handleChange}
                      variant="outlined"
                      size="small"
                      sx={{ mt: 1 }}
                    />
                  )}
                </Grid>
                <Grid item xs={5}>
                  <RadioGroup
                    row
                    name={`${item.replace(/\s+/g, '')}Present`}
                    value={formData[`${item.replace(/\s+/g, '')}Present`] || 'No'}
                    onChange={handleChange}
                  >
                    <FormControlLabel value="Yes" control={<Radio size="small" />} label="Present" />
                    <FormControlLabel value="No" control={<Radio size="small" />} label="Absent" />
                  </RadioGroup>
                  {formData[`${item.replace(/\s+/g, '')}Present`] === 'Yes' && (
                    <TextField
                      fullWidth
                      label="Specify"
                      name={`${item.replace(/\s+/g, '')}Specify`}
                      value={formData[`${item.replace(/\s+/g, '')}Specify`] || ''}
                      onChange={handleChange}
                      variant="outlined"
                      size="small"
                      sx={{ mt: 1 }}
                    />
                  )}
                </Grid>
                <Grid item xs={2}>
                  <IconButton onClick={() => handleRemoveFamilyBackground(item)}>
                    <DeleteIcon color="error" />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
          </Grid>
        )}

        {/* Prenatal History Section */}
        <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
          Prenatal History
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2} direction="column">
          {[
            { field: 'diabetes', label: 'Diabetes' },
            { field: 'bp', label: 'BP' },
            { field: 'vomiting', label: 'Excessive Vomiting' },
            { field: 'elderlyPregnancy', label: 'Elderly Pregnancy' },
            { field: 'abortion', label: 'H/o Abortion' },
            { field: 'ototoxicMedication', label: 'Ototoxic Medication' },
            { field: 'radiationExposure', label: 'Exposure to Radiation/Chemical Fumes' },
            { field: 'infections', label: 'Infections' },
            { field: 'complications', label: 'Complications' },
          ].map((item) => (
            <Grid item key={item.field}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} sm={3} md={2}>
                  <Typography variant="body2">{item.label}</Typography>
                </Grid>
                <Grid item>
                  <RadioGroup
                    row
                    name={item.field}
                    value={formData[item.field]}
                    onChange={handleChange}
                  >
                    <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                    <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                  </RadioGroup>
                </Grid>
                {formData[item.field] === 'Yes' && (
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      label={`Specify ${item.label}`}
                      name={`specify${item.field.charAt(0).toUpperCase() + item.field.slice(1)}`}
                      value={formData[`specify${item.field.charAt(0).toUpperCase() + item.field.slice(1)}`]}
                      onChange={handleChange}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          ))}

          <Grid item>
            <FormControl fullWidth size="small">
              <InputLabel>Rh Incompatibility</InputLabel>
              <Select
                name="rhIncompatibility"
                value={formData.rhIncompatibility}
                onChange={handleChange}
                label="Rh Incompatibility"
              >
                <MenuItem value="Positive">Positive</MenuItem>
                <MenuItem value="Negative">Negative</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item>
            <Typography variant="body2" sx={{ mb: 1 }}>Habits</Typography>
            <Grid container spacing={2}>
              <Grid item>
                <FormControl component="fieldset">
                  <Typography variant="caption">Alcohol</Typography>
                  <RadioGroup
                    row
                    name="alcohol"
                    value={formData.habits.alcohol}
                    onChange={(e) => handleNestedChange('habits', 'alcohol', e.target.value)}
                  >
                    <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                    <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl component="fieldset">
                  <Typography variant="caption">Smoking</Typography>
                  <RadioGroup
                    row
                    name="smoking"
                    value={formData.habits.smoking}
                    onChange={(e) => handleNestedChange('habits', 'smoking', e.target.value)}
                  >
                    <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                    <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Perinatal History Section */}
        <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
          Perinatal History
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2} direction="column">
          {/* Full Term */}
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={3} md={2}>
                <Typography variant="body2">Full Term</Typography>
              </Grid>
              <Grid item>
                <RadioGroup
                  row
                  name="fullTerm"
                  value={formData.fullTerm}
                  onChange={handleChange}
                >
                  <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                  <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                </RadioGroup>
              </Grid>
              {formData.fullTerm === 'No' && (
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    label="Premature (Specify Months/Days)"
                    name="premature"
                    value={formData.premature}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Jaundice */}
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={3} md={2}>
                <Typography variant="body2">Jaundice</Typography>
              </Grid>
              <Grid item>
                <RadioGroup
                  row
                  name="jaundice"
                  value={formData.jaundice}
                  onChange={handleChange}
                >
                  <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                  <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                </RadioGroup>
              </Grid>
              {formData.jaundice === 'Yes' && (
                <>
                  <Grid item xs={12} sm={3} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Jaundice Timing</InputLabel>
                      <Select
                        name="jaundiceTiming"
                        value={formData.jaundiceTiming}
                        onChange={handleChange}
                        label="Jaundice Timing"
                      >
                        <MenuItem value="First day">First day</MenuItem>
                        <MenuItem value="Later">Later</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      fullWidth
                      label="Treatment"
                      name="treatment"
                      value={formData.treatment}
                      onChange={handleChange}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>

          {/* Type of Delivery */}
          <Grid item>
            <FormControl fullWidth size="small">
              <InputLabel>Type of Delivery</InputLabel>
              <Select
                name="deliveryType"
                value={formData.deliveryType}
                onChange={handleChange}
                label="Type of Delivery"
              >
                <MenuItem value="Normal">Normal</MenuItem>
                <MenuItem value="Breech">Breech</MenuItem>
                <MenuItem value="C Section">C-Section</MenuItem>  
                <MenuItem value="Instrumental">Instrumental</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Prolonged Labour */}
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={3} md={2}>
                <Typography variant="body2">Prolonged Labour</Typography>
              </Grid>
              <Grid item>
                <RadioGroup
                  row
                  name="prolongedLabour"
                  value={formData.prolongedLabour}
                  onChange={handleChange}
                >
                  <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                  <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                </RadioGroup>
              </Grid>
            </Grid>
          </Grid>

          {/* Birth Cry */}
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={3} md={2}>
                <InputLabel>Birth Cry</InputLabel>
              </Grid>
              <Grid item>
                <Select
                  name="birthCry"
                  value={formData.birthCry}
                  onChange={handleChange}
                  size="small"
                >
                  <MenuItem value="Immediate">Immediate</MenuItem>
                  <MenuItem value="Delayed">Delayed</MenuItem>
                </Select>
              </Grid>
              {formData.birthCry === 'Delayed' && (
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    label="Delayed Cry Duration"
                    name="delayedCryDuration"
                    value={formData.delayedCryDuration}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* NICU */}
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={3} md={2}>
                <Typography variant="body2">NICU</Typography>
              </Grid>
              <Grid item>
                <RadioGroup
                  row
                  name="nicu"
                  value={formData.nicu}
                  onChange={handleChange}
                >
                  <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                  <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                </RadioGroup>
              </Grid>
              {formData.nicu === 'Yes' && (
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    label="NICU Days"
                    name="nicuDays"
                    value={formData.nicuDays}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* APGAR Scores */}
          <Grid item>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="APGAR Score (Immediate)"
                  name="apgarImmediate"
                  value={formData.apgarImmediate}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="APGAR Score (5 min)"
                  name="apgar5min"
                  value={formData.apgar5min}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Multiple Radio Items (Like Hypoxia, etc.) */}
          {[
            { field: 'hypoxia', label: 'Hypoxia' },
            { field: 'headTrauma', label: 'Head Trauma' },
            { field: 'neonatalJaundice', label: 'Neonatal Jaundice' },
            { field: 'fetalDistress', label: 'Fetal Distress' },
            { field: 'birthAsphyxia', label: 'Birth Asphyxia' },
            { field: 'amnioticAspiration', label: 'Amniotic Aspiration' },
            { field: 'postnatalInfections', label: 'Infections' },
          ].map((item) => (
            <Grid item key={item.field}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={3} md={2}>
                  <Typography variant="body2">{item.label}</Typography>
                </Grid>
                <Grid item>
                  <RadioGroup
                    row
                    name={item.field}
                    value={formData[item.field]}
                    onChange={handleChange}
                  >
                    <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                    <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                  </RadioGroup>
                </Grid>
                {formData[item.field] === 'Yes' && (
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      label={`Specify ${item.label}`}
                      name={`specify${item.field.charAt(0).toUpperCase() + item.field.slice(1)}`}
                      value={formData[`specify${item.field.charAt(0).toUpperCase() + item.field.slice(1)}`]}
                      onChange={handleChange}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          ))}

          {/* Vegetative Skills */}
          <Grid item>
            <FormControl fullWidth size="small">
              <InputLabel>Vegetative Skills</InputLabel>
              <Select
                name="vegetativeSkills"
                value={formData.vegetativeSkills}
                onChange={handleChange}
                label="Vegetative Skills"
              >
                <MenuItem value="Poor">Poor</MenuItem>
                <MenuItem value="Good">Good</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Other Findings */}
          <Grid item>
            <TextField
              fullWidth
              label="Other Findings"
              name="otherFindings"
              value={formData.otherFindings}
              onChange={handleChange}
              variant="outlined"
              size="small"
              multiline
              rows={2}
            />
          </Grid>
        </Grid>


        {/* Post Natal History & Reflexes */}
        <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
          Post Natal History & Reflexes
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {Object.keys(formData.reflexes).map((reflex) => (
            <Grid item xs={12} sm={6} md={4} key={reflex}>
              <FormControl component="fieldset" fullWidth>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  {reflex.charAt(0).toUpperCase() + reflex.slice(1)} Reflex
                </Typography>
                <RadioGroup
                  row
                  name={reflex}
                  value={formData.reflexes[reflex]}
                  onChange={(e) => handleNestedChange('reflexes', reflex, e.target.value)}
                >
                  <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                  <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                </RadioGroup>
              </FormControl>
            </Grid>
          ))}
        </Grid>
        {/* Tests Section */}
        <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
          Tests
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {/* OAE Test */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>OAE Test</Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Type</InputLabel>
                <Select
                  value={formData.oae.type}
                  onChange={(e) => handleNestedChange('oae', 'type', e.target.value)}
                  label="Type"
                  displayEmpty
                  renderValue={value => value || "Select Type"}
                >
                  <MenuItem value="TEAOEs">TEAOEs</MenuItem>
                  <MenuItem value="DPOAEs">DPOAEs</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Trial</InputLabel>
                <Select
                  value={formData.oae.trial}
                  onChange={(e) => handleNestedChange('oae', 'trial', e.target.value)}
                  label="Trial"
                  displayEmpty
                  renderValue={value => value || "Select Trial"}
                >
                  <MenuItem value="1">Trial 1</MenuItem>
                  <MenuItem value="2">Trial 2</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <TableContainer component={Paper} sx={{ mb: 3 }}>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell>Ear</TableCell>
                  <TableCell align="center">Right</TableCell>
                  <TableCell align="center">Left</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Result</TableCell>
                  <TableCell align="center">
                    <FormControl fullWidth size="small">
                      <Select
                        value={formData.oae.rightResult || ''}
                        onChange={(e) => handleNestedChange('oae', 'rightResult', e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value="Pass">Pass</MenuItem>
                        <MenuItem value="Refer">Refer</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell align="center">
                    <FormControl fullWidth size="small">
                      <Select
                        value={formData.oae.leftResult || ''}
                        onChange={(e) => handleNestedChange('oae', 'leftResult', e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value="Pass">Pass</MenuItem>
                        <MenuItem value="Refer">Refer</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* BOA Test */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>BOA Test</Typography>

          {/* Trial Selector */}
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Trial</InputLabel>
                <Select
                  value={formData.boa.trial}
                  onChange={(e) => handleNestedChange('boa', 'trial', e.target.value)}
                  label="Trial"
                  displayEmpty
                  renderValue={value => value || "Select Trial"}
                >
                  <MenuItem value="1">Trial 1</MenuItem>
                  <MenuItem value="2">Trial 2</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <TableContainer component={Paper} sx={{ mb: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Stimulus</TableCell>
                  <TableCell align="center">Intensity (dB)</TableCell>
                  <TableCell align="center">Response</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {["500 Hz", "1k Hz", "2k Hz", "4k Hz", "Speech", "Noise"].map((stimulus) => (
                  <TableRow key={stimulus}>
                    <TableCell>{stimulus}</TableCell>

                    {/* Intensity TextField */}
                    <TableCell align="center">
                      <TextField
                        size="small"
                        value={formData.boa.responses[stimulus]?.intensity || ""}
                        onChange={(e) =>
                          handleBoaChange(stimulus, "intensity", e.target.value)
                        }
                        sx={{ width: 120 }}
                      />
                    </TableCell>

                    {/* Response TextField */}
                    <TableCell align="center">
                      <TextField
                        size="small"
                        value={formData.boa.responses[stimulus]?.response || ""}
                        onChange={(e) =>
                          handleBoaChange(stimulus, "response", e.target.value)
                        }
                        sx={{ width: 120 }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Results Selector */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Results</InputLabel>
                <Select
                  value={formData.boa.results}
                  onChange={(e) => handleNestedChange('boa', 'results', e.target.value)}
                  label="Results"
                  displayEmpty
                  renderValue={value => value || "Select Results"}
                >
                  <MenuItem value="Pass">Pass</MenuItem>
                  <MenuItem value="Refer">Refer</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        {/* AABR Test */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>AABR Test</Typography>

          {/* Trial Selector */}
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Trial</InputLabel>
                <Select
                  value={formData.aabr.trial}
                  onChange={(e) => handleNestedChange('aabr', 'trial', e.target.value)}
                  label="Trial"
                  displayEmpty
                  renderValue={value => value || "Select Trial"}
                >
                  <MenuItem value="1">Trial 1</MenuItem>
                  <MenuItem value="2">Trial 2</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Responses Table */}
          <TableContainer component={Paper} sx={{ mb: 2 }}>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell>Intensity (dB)</TableCell>
                  <TableCell align="center">Right</TableCell>
                  <TableCell align="center">Left</TableCell>
                </TableRow>
                {['30', '35', '40'].map((intensity) => (
                  <TableRow key={intensity}>
                    <TableCell>{intensity}</TableCell>
                    <TableCell align="center">
                      <FormControl fullWidth size="small">
                        <Select
                          value={formData.aabr.responses?.[intensity]?.right || ''}
                          onChange={(e) => handleAabrResponseChange(intensity, 'right', e.target.value)}
                          displayEmpty
                        >
                          <MenuItem value="Pass">Pass</MenuItem>
                          <MenuItem value="Refer">Refer</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="center">
                      <FormControl fullWidth size="small">
                        <Select
                          value={formData.aabr.responses?.[intensity]?.left || ''}
                          onChange={(e) => handleAabrResponseChange(intensity, 'left', e.target.value)}
                          displayEmpty
                        >
                          <MenuItem value="Pass">Pass</MenuItem>
                          <MenuItem value="Refer">Refer</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Results Selector */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Results</InputLabel>
                <Select
                  value={formData.aabr.results}
                  onChange={(e) => handleNestedChange('aabr', 'results', e.target.value)}
                  label="Results"
                  displayEmpty
                  renderValue={value => value || "Select Results"}
                >
                  <MenuItem value="Pass">Pass</MenuItem>
                  <MenuItem value="Refer">Refer</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        {/* Diagnosis & Recommendation */}
        <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
          Recommendation
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={12}>

            <Grid container spacing={1}>
              {recommendationServices.map((service) => (
                <Grid item xs={12} sm={6} md={4} key={service.field}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={service.field}
                        checked={formData.recommendation[service.field] || false}
                        onChange={(e) =>
                          handleNestedChange('recommendation', service.field, e.target.checked)
                        }
                        size="small"
                      />
                    }
                    label={
                      <Typography variant="body1">
                        {service.label}
                      </Typography>
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
       <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Download Data
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Format"
              >
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
        {/* Submit Button */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Button
            type="submit"
            variant="contained"
            size="large"
            sx={{ px: 6, py: 1.5, fontSize: '1.1rem' }}
          >
            Submit Form
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default NewbornForm;